// First ensure theme functions exist
window.theme = window.theme || {};
window.theme.debounce =
  window.theme.debounce ||
  function (fn, wait) {
    let timeout;
    return function () {
      const context = this,
        args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(context, args), wait);
    };
  };

window.theme.getWindowWidth =
  window.theme.getWindowWidth ||
  function () {
    return window.innerWidth || document.documentElement.clientWidth;
  };

// Main slider initialization
function initLogoSlider() {
  const sliderEl = document.querySelector("[data-slider-logos]");
  if (!sliderEl) return;

  // Ensure Flickity is available
  if (!window.Flickity && !window.theme.Flickity) {
    console.warn("Flickity not loaded");
    return;
  }

  const FlickityConstructor = window.theme.Flickity || window.Flickity;

  const flkty = new FlickityConstructor(sliderEl, {
    cellAlign: "left",
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true,
    autoPlay: 4000,
    draggable: true,
    watchCSS: false,
    selectedAttraction: 0.05,
    friction: 0.8,
  });

  // Double refresh for reliability
  setTimeout(() => flkty.resize(), 300);
  setTimeout(() => flkty.resize(), 600);

  // Shopify editor support
  if (window.Shopify?.designMode) {
    document.addEventListener("shopify:block:select", (e) => {
      const slide = e.target.closest("[data-slide]");
      if (slide) {
        const index = parseInt(slide.getAttribute("data-slide-index"));
        flkty.select(index);
      }
    });
  }
}

// Initialize with multiple fallbacks
function startInitialization() {
  // First try when DOM is ready
  if (document.readyState !== "loading") {
    setTimeout(initLogoSlider, 300);
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(initLogoSlider, 300);
    });
  }

  // Final fallback
  window.addEventListener("load", initLogoSlider);
}

// Start the process
startInitialization();
